export default __webpack_public_path__ + "static/media/nv4.ce91ec08.PNG";